export default __webpack_public_path__ + "static/media/Insurance Agent.159c836a.png";